// extracted by mini-css-extract-plugin
export default {"archived":"styles_archived__TnHRX","text":"styles_text__IWaN-","svg":"styles_svg__M8iHP"};